module.exports = __webpack_public_path__ + "static/media/tutorial.f12f04c3.md";